var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMusic24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.757 11.023l-4.083 1.166a.583.583 0 00-.424.56v2.942a1.83 1.83 0 00-.587 0h-.007c-.66.112-1.156.581-1.156 1.142 0 .645.653 1.167 1.458 1.167.806 0 1.459-.522 1.459-1.167V13.19l2.916-.833v2.75a1.84 1.84 0 00-.725.029c-.593.148-1.025.59-1.025 1.114 0 .645.654 1.167 1.459 1.167s1.458-.522 1.458-1.167v-4.667c0-.154-.06-.3-.167-.408v-.001a.58.58 0 00-.138-.104l-.013-.006a.58.58 0 00-.425-.041z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21.5A2.5 2.5 0 015 19V5a2.5 2.5 0 012.5-2.5h6.665a.5.5 0 01.36.153l4.335 4.499a.5.5 0 01.14.347V19a2.5 2.5 0 01-2.5 2.5h-9zM6 19a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0018 19V8h-2.5a2 2 0 01-2-2V3.5h-6A1.5 1.5 0 006 5v14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic24);
export default __webpack_public_path__ + "static/media/icon-music-24.3caef157.svg";
export { ForwardRef as ReactComponent };